import { compose } from "redux";

import NewProviderPost from "./NewOrEdit";
import Default from "./Default";
import Error from "../Error";
import withContainer from "../common/hoc/WithContainer";
import extractMandatoryFields from "./ExtractMandatoryFields";

import { createProviderPost } from "../../services/MODSService";
import injectAuthStoreAsProps from "../InjectAuthStoreAsProps";

export default compose(
    injectAuthStoreAsProps(),
    extractMandatoryFields(),
    withContainer({
        dataParams: {
            saveHandler: createProviderPost
        },
        Error,
        DefaultComponent: Default
    })
)(NewProviderPost);
